<template>
  <div class="order-page">
    <div class="container page">
      <form @submit.prevent="onSubmit()">
        <fieldset :disabled="inProgress">
          <legend>
            <h1>訂單</h1>
          </legend>
          <table class="table">
            <thead>
              <tr>
                <th class="text-left">餐點名稱</th>
                <th>價格</th>
                <th>數量</th>
                <th>小計</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(meal, index) in order.orderMeals" :key="index">
                <td class="text-left">{{meal.name}}</td>
                <td>{{meal.price}}</td>
                <td>{{meal.quantity}}</td>
                <td>{{meal.quantity*meal.price}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th class="text-left">總額:</th>
                <td></td>
                <td></td>
                <td>{{order.amount}}</td>
              </tr>
            </tfoot>
          </table>
          <div class="input-group col-md-6 offset-md-3 col-xs-12">
            <div class="input-group-prepend">
              <span class="input-group-text">電話</span>
            </div>
            <input type="tel" class="form-control" v-model="order.phone" placeholder="請輸入" />
          </div>
          <hr />
        </fieldset>
        <button :disabled="inProgress" class="btn btn-secondary pull-xs-right" type="submit">確定</button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "OrderEdit",
  methods: {
    onSubmit() {
      this.$store.dispatch("hasOrderUnfinished").then((orderUnfinished)=>{
        if(orderUnfinished){
          alert("還有訂單還沒完成驗證")
          this.$router.push({ path: "/order/"+orderUnfinished });
        }else{
          this.$store.dispatch("orderCreate").then(resp => {
            this.$router.push({ path: "/order/"+resp.orderId });
          }).catch(err=>{
            alert("訂單建立失敗: "+err)
            return false;
          });
        }
      })
    }
  },
  data() {
    return {
      inProgress: false,
      errors: {}
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(["order"])
  }
};
</script>
